import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./redux/index";
import "react-toastify/dist/ReactToastify.css";
import i18n from "../src/translation/i18n"; // Import your i18n setup
import { I18nextProvider } from "react-i18next";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
      <ToastContainer />
    </Provider>
  </React.StrictMode>
);
